import { FC } from 'react';
import {
  Field,
  FileField,
  ImageField,
  TextField,
  withDatasourceCheck,
} from '@sitecore-jss/sitecore-jss-nextjs';
import dynamic from 'next/dynamic';

import { ComponentProps } from '@gn-audio/jss-components';

type VideoSpotProps = {
  fields: {
    videoLg: FileField;
    videoMd: FileField;
    videoXs: FileField;
    videoLgApple: FileField;
    videoMdApple: FileField;
    videoXsApple: FileField;
    image: ImageField;
    text: TextField;
    textShared: TextField;
    backgroundContrast: Field<number>;
    youtubeVideoID: TextField;
    youkuVideoID: TextField;
    reducedWidth: Field<boolean>;
    hideControls: Field<boolean>;
    unlockAspectRatio: Field<boolean>;
    backgroundColor: TextField;
    backgroundColorShared: TextField;
    textColor: TextField;
    firstCtaButtonTrackingName?: Field<string>;
    trackingSpotName?: Field<string>;
  };
} & ComponentProps;

const VideoSpotComposable = dynamic(
  () => import('composables/Product/VideoSpot/VideoSpotComposable'),
  {
    loading: () => (
      <div className="flex aspect-video animate-pulse items-center justify-center bg-gray-200">
        <div className="text-gray-500">Loading video component...</div>
      </div>
    ),
  }
);

const VideoSpot: FC<VideoSpotProps> = (props) => {
  return <VideoSpotComposable {...props} />;
};

export default withDatasourceCheck()<VideoSpotProps>(VideoSpot);
